import { createContext, useContext, useState, useCallback } from 'react';

const STRINGS = {
  sr: {
    appName: 'FinArt Studio',
    login: 'Prijava',
    register: 'Registracija',
    email: 'Email',
    password: 'Lozinka',
    rememberMe: 'Zapamtite me',
    forgotPassword: 'Zaboravili ste lozinku?',
    noAccount: 'Još uvek nemate nalog?',
    signUp: 'Registrujte se',
    haveAccount: 'Već imate nalog?',
    signIn: 'Prijavite se',
    dashboard: 'Početna',
    invoicing: 'Fakturisanje',
    fiscalCash: 'Fiskalna kasa',
    taxes: 'Porezi i doprinosi',
    clients: 'Klijenti',
    products: 'Proizvodi i usluge',
    kpoBook: 'KPO knjiga',
    exchangeList: 'Kursna lista',
    taxCalendar: 'Poreski kalendar',
    userProfile: 'Profil korisnika',
    agency: 'Agencija',
    subscription: 'Pretplata',
    referrals: 'Preporuke',
    newInvoice: 'Nova Faktura',
    newProforma: 'Nova Profaktura',
    newClient: 'Novi klijent',
    limits: 'Limiti',
    invoicedYear: 'Fakturisano (tek. god.)',
    collected365: 'Naplaćeno (365 dana)',
    remaining: 'Preostalo',
    nextDeadline: 'Sledeći rok',
    monthlyDue: 'Mesečna obaveza',
    markPaid: 'Označi kao plaćeno',
    paid: 'Plaćeno',
    dueSoon: 'Za 10 dana',
    topClients: 'Top 4 klijenta',
    allClients: 'Svi klijenti',
    foreignEntity: 'Strani entitet',
    countryLabel: 'Država',
    deleteCustomerBtn: 'Obriši klijenta',
    deleteCustomerConfirm1: (name) => `Da li želite da obrišete klijenta „${name}“?`,
    deleteCustomerConfirm2: 'Poslednja provera: brisanje je trajno i ne može se poništiti.',
    deleteContinueBtn: 'Nastavi',
    deleteFinalBtn: 'Da, trajno obriši',
    deletingEllipsis: 'Brisanje...',
    yearLabel: 'Godina',
    switchAccount: 'Promeni nalog',
    yearTotalShort: (y) => `Ukupno ${y}.`,
    addAccountBtn: 'Dodaj nalog',
    daysLeft: (n) => `za ${n} ${n % 10 === 1 && n % 100 !== 11 ? 'dan' : 'dana'}`,
    limitRemaining: (rest, pct) => `Preostalo ${rest} · iskorišćeno ${pct}`,
    tabAllClients: 'Svi klijenti',
    stAll: 'Sve',
    stDraft: 'U pripremi',
    stSent: 'Poslato',
    stPaid: 'Naplaćeno',
    stCancelled: 'Stornirano',
    stPartial: 'Delimično',
    statInvoiced: 'Fakturisano (RSD)',
    statPaid: 'Naplaćeno (RSD)',
    statUnpaid: 'Nenaplaćeno (RSD)',
    statCount: 'Broj faktura',
    tabInvoicesOnly: 'Fakture',
    tabFiscalOnly: 'Fiskalni računi',
    downloadReport: 'Preuzmi izveštaj',
    markPaidAction: 'Označi kao naplaćeno',
    changeStatus: 'Promeni status',
    partialAmountLabel: (cur) => `Uplaćeno (${cur})`,
    colSeqShort: 'Redni broj',
    colInvoiceNo: 'Broj fakture',
    colInvoiceDate: 'Datum fakture',
    colTotal: 'Ukupno',
    colStatus: 'Status',
    paidOfTotal: (p) => `uplaćeno ${p}`,
    tabDomestic: 'Domaći',
    tabForeign: 'Strani',
    colName: 'Ime',
    colAddress: 'Adresa',
    colMb: 'Matični broj',
    showLabel: 'Prikaži:',
    viewBtn: 'Pregled',
    pageRange: (a, b, n) => `${a}–${b} od ${n}`,
    prevPage: 'Prethodna',
    nextPage: 'Sledeća',
    clientDocuments: 'Dokumenti klijenta',
    noClientDocuments: 'Za ovog klijenta još nema izdatih dokumenata.',
    clientDetailsTitle: 'Podaci o klijentu',
    searchAgenciesPlaceholder: 'Pretraži po imenu (npr. Zlatan, Vidovic)...',
    myAgencyLabel: 'Moja agencija',
    renameAgency: 'Promeni naziv',
    markAsMine: 'Označi kao moju agenciju',
    unmarkMine: 'Ukloni oznaku',
    agenciesCount: (n) => `${n} ${n % 10 === 1 && n % 100 !== 11 ? 'nalog' : 'naloga'}`,
    starTip: 'Savet: kliknite ☆ pored svoje agencije da bude uvek prva na listi.',
    backToCurrentYear: (y) => `← Nazad na ${y}.`,
    editDocumentHeading: 'Izmena dokumenta',
    numberSuggestedNote: 'Predlog sledećeg broja — možete ga promeniti.',
    deleteInvoiceConfirm1: (num) => `Da li želite da obrišete dokument${num ? ' ' + num : ''}? Nestaće i iz KPO knjige i iz limita.`,
    deleteInvoiceConfirm2: 'Poslednja provera: brisanje dokumenta je trajno i ne može se poništiti.',
    customerHasInvoices: (n) => `Ovaj klijent se ne može obrisati jer je vezan za ${n} ${n === 1 ? 'dokument' : 'dokumenta'}. Izdate fakture moraju da zadrže podatke o primaocu.`,
    domesticEntity: 'Domaći entitet',
    currentYear: 'Tekuća godina',
    lastYear: 'Prošla godina',
    months3: '3 meseca',
    months6: '6 meseci',
    all: 'Sve',
    logout: 'Odjava',
    brandHeadline1: 'Vi stvarate umetnost,',
    brandHeadline2: 'mi brinemo o Vašim finansijama.',
    brandSub: 'Poreske i administrativne usluge za umetnike i agencije.',
    loadingGeneric: 'Učitavanje...',
    taxesCard: 'Porezi',
    yearSuffix: 'godina',
    paidShort: '✓ Plaćeno',
    savingEllipsis: 'Čuvanje...',
    deadlinePassed: 'Rok je prošao',
    nextPaymentIn: (n) => `Sledeća uplata za ${n} dana`,
    invoicedTitle: 'Fakturisano',
    noInvoicedYet: 'Još nema fakturisanih iznosa.',
    allClientsArrow: 'Svi klijenti →',
    newDocument: '+ Novi dokument',
    filterAll: 'Sve',
    filterInvoices: 'Fakture',
    filterProforma: 'Profakture',
    filterFiscal: 'Fiskalni',
    noDocuments: 'Nema dokumenata za prikaz.',
    kindInvoice: 'Faktura',
    kindProforma: 'Profaktura',
    kindFiscal: 'Fiskalni',
    newClientBtn: '+ Dodaj klijenta',
    searchClients: 'Pretražite',
    noClientsYet: 'Još nemate dodatih klijenata.',
    noSearchResults: 'Nema rezultata za pretragu.',
    backToClients: '← Klijenti',
    editClient: 'Izmeni klijenta',
    newClientHeading: 'Novi klijent',
    pibLabel: 'PIB',
    pibPlaceholder: 'Unesite PIB',
    fullNameLabel: 'Ime i prezime / naziv *',
    fullNamePlaceholder: 'npr. Marko Petrović',
    agencyNameLabel: 'Naziv agencije / firme',
    mbLabel: 'Matični broj',
    regDateLabel: 'Datum registracije',
    activityCodeLabel: 'Šifra delatnosti',
    chooseActivityCode: 'Izaberite šifru delatnosti',
    cityLabel: 'Grad',
    postalCodeLabel: 'Poštanski broj',
    streetLabel: 'Ulica',
    streetNumberLabel: 'Broj',
    phoneLabel: 'Telefon',
    emailLabel: 'Email',
    domesticAccountSection: 'Domaći račun (RSD)',
    accountNumberLabel: 'Broj računa',
    foreignAccountSection: 'Inostrani račun (devizni)',
    ibanLabel: 'IBAN',
    bankNameLabel: 'Naziv banke',
    swiftLabel: 'SWIFT/BIC',
    savingEllipsisShort: 'Čuvanje...',
    saveChanges: 'Sačuvaj izmene',
    addClientBtn: 'Dodaj klijenta',
    backArrow: '← Nazad',
    newDocumentHeading: 'Novi dokument',
    docKindInvoice: 'Faktura',
    docKindProforma: 'Profaktura',
    docKindFiscal: 'Fiskalni račun',
    actorLabel: 'Klijent (umetnik za koga fakturišete) *',
    chooseClient: 'Izaberite klijenta',
    invoiceTypeLabel: 'Tip fakture',
    domesticTab: 'Domaća',
    foreignTab: 'Inostrana',
    foreignInfoPrefix: 'ℹ️ Inostrane fakture',
    foreignInfoNotIncl: 'ne ulaze',
    foreignInfoMid: 'u limit za PDV (8M), ali',
    foreignInfoIncl: 'ulaze',
    foreignInfoSuffix: 'u limit za paušal (6M).',
    accountPrefix: 'Račun: ',
    ibanPrefix: 'IBAN: ',
    customerLabel: 'Klijent (kome se izdaje dokument)',
    documentNumberLabel: 'Broj dokumenta',
    serviceDescLabel: 'Opis usluge *',
    serviceDescPlaceholder: 'npr. Honorar za nastup',
    issueDateLabel: 'Datum izdavanja *',
    serviceDateLabel: 'Datum prometa *',
    placeOfIssueLabel: 'Mesto izdavanja',
    placeOfIssuePlaceholder: 'npr. Beograd',
    amountRsdLabel: 'Iznos (RSD) *',
    amountLabel: 'Iznos *',
    currencyLabel: 'Valuta *',
    rateLabel: (cur) => `Kurs (${cur} → RSD) *`,
    nbsButton: 'NBS kurs',
    nbsNote: (date) => `Srednji kurs NBS na dan ${date}`,
    saveDocument: 'Sačuvaj dokument',
    kpoTitle: 'KPO knjiga',
    printPdf: 'Štampaj / PDF',
    kpoSub: 'Evidencija o prometu za paušalno oporezovane obveznike — knjiga prometa.',
    noRecordsForYear: (y) => `Nema evidentiranih dokumenata za ${y}. godinu.`,
    colSeq: 'Red. br.',
    colServiceDate: 'Datum prometa',
    colPaymentDate: 'Datum naplate',
    colCustomer: 'Kupac',
    colAmountRsd: 'Iznos (RSD)',
    totalForYear: (y) => `UKUPNO ZA ${y}. GODINU:`,
    taxesHeading: 'Porezi i doprinosi',
    taxesSub: 'Evidencija plaćanja paušalnog poreza i doprinosa po mesecima.',
    monthNames: ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar'],
    exchangeError: 'Nije moguće preuzeti kursnu listu. Pokušajte ponovo kasnije.',
    exchangeHeading: 'Kursna lista',
    fetchNbsBtn: 'Preuzmi NBS kurs',
    exchangeSub: 'Srednji kurs Narodne banke Srbije za odabrane valute.',
    exchangeEmpty: 'Kliknite na "Preuzmi NBS kurs" da učitate trenutnu kursnu listu.',
    notAvailable: 'Nije dostupno',
    taxCalendarHeading: 'Poreski kalendar',
    taxCalendarSub: 'Paušalni obveznici plaćaju porez i doprinose do 15. u mesecu za prethodni mesec.',
    taxRowTitle: 'Porez i doprinosi — paušal',
    taxRowSub: (period) => `Za period: ${period}`,
    nextDeadlineBadge: 'Sledeći rok',
    taxNote: (amount) => `Iznos mesečne obaveze zavisi od osnovice i opštine registracije. Trenutno prikazan orijentacioni iznos na početnoj je ${amount} — provjerite tačan iznos u rešenju Poreske uprave.`,
    passwordChanged: 'Lozinka je uspešno promenjena.',
    passwordChangeError: 'Greška prilikom promene lozinke.',
    emailAddress: 'Email adresa',
    appLanguage: 'Jezik aplikacije',
    serbianLabel: 'Srpski',
    englishLabel: 'English',
    russianLabel: 'Ruski',
    changePassword: 'Promena lozinke',
    newPasswordPlaceholder: 'Nova lozinka (min. 6 karaktera)',
    changePasswordBtn: 'Promeni lozinku',
    companyNameLabel: 'Naziv firme *',
    accountsSection: 'Računi',
    domesticAccountLabel: 'Dinarski tekući račun',
    foreignIbanLabel: 'Devizni IBAN',
    bankLabel: 'Banka',
    savedNote: 'Sačuvano.',
    welcomeHeading: 'Dobrodošli u FinArt Studio!',
    welcomeSub: 'Pre nego što krenemo, recite nam odakle počinjemo. Vodićemo Vas pravim putem.',
    haveAgencyTitle: 'Već imam agenciju',
    haveAgencyDesc: 'Imate registrovanu firmu i PIB? Dodajte je u sistem i kreirajte prvu fakturu.',
    newAgencyTitle: 'Tek otvaram agenciju',
    newAgencyDesc: 'Naš tim vodi ceo postupak registracije kod APR-a. Vi dostavljate kopiju lične karte i potpisujete punomoćje.',
    onboardingFootnote: 'Niste sigurni? Možete se kasnije predomisliti. Usluge su dostupne iz menija.',
    openingAgencyHeading: 'Otvaranje paušalne agencije',
    openingAgencySub: 'Ova usluga je u pripremi. Za sada nas kontaktirajte direktno na email kako bismo Vam pomogli da otvorite firmu kod APR-a.',
    backArrowOnboarding: '← Nazad',
    addYourCompanyHeading: 'Dodajte vašu firmu',
    addYourCompanySub: 'Dodajte podatke Vaše firme kako biste mogli da šaljete fakture i evidentirate uplate.',
    pibFullLabel: 'Poreski identifikacioni broj (PIB)',
    streetSeatLabel: 'Ulica sedišta',
    bankForeignLabel: 'Banka (za devizni račun)',
    saveAndContinue: 'Sačuvaj i nastavi',
    newManualCustomer: 'Novi klijent — ručni unos',
    backToSearch: '← Pretraga',
    customerNamePlaceholder: 'Naziv klijenta *',
    pibShort: 'PIB',
    mbShort: 'Matični broj',
    addressPlaceholder: 'Adresa',
    cityPlaceholder: 'Grad',
    postalCodePlaceholder: 'Poštanski broj',
    foreignEntityCheckbox: 'Strani entitet',
    saveCustomerBtn: 'Sačuvaj klijenta i koristi na fakturi',
    typeCustomerName: 'Počnite da kucate naziv klijenta...',
    newManualBtn: '+ Novi klijent (ručni unos)',
    confirmDeleteDocument: 'Obrisati ovaj dokument?',
    confirmDeleteClient: 'Obrisati klijenta i sve njegove fakture?',
    editBtn: 'Izmeni',
    deleteBtn: 'Obriši',
    totalBalance: 'Ukupni saldo',
    domesticRsdLabel: 'Domaće (RSD)',
    foreignLabel: (cur) => `Inostrane (${cur})`,
    flatRateLimitsTitle: 'Limiti paušala',
    flatRateCalYear: (y) => `Paušal — kalendarska god. ${y}`,
    vatLast365: 'PDV — poslednjih 365 dana',
    documentsTab: 'Dokumenti',
    profileTab: 'Profil klijenta',
    documentsCount: (n) => `Dokumenti (${n})`,
    domesticFilterFlag: 'Domaće',
    foreignFilterFlag: 'Inostrane',
    noDocuments2: 'Nema dokumenata.',
    issuedShort: (date) => `Izd: ${date}`,
    pdfBtn: 'PDF',
    fullNameInfo: 'Ime i prezime',
    agencyInfo: 'Agencija',
    addressInfo: 'Adresa',
    activityCodeInfo: 'Šifra delatnosti',
    domesticAccountSectionInfo: 'Domaći račun',
    accountNumberInfo: 'Broj računa',
    foreignAccountSectionInfo: 'Inostrani račun',
    bankInfo: 'Banka',
    notSetInfo: 'Nije unesen',
    documentNotFound: 'Dokument nije pronađen.',
    printSaveBtn: 'Štampaj / Sačuvaj PDF',
    productsHeading: 'Proizvodi i usluge',
    productsSub: 'Sačuvajte često korišćene stavke da brže popunjavate fakture.',
    serviceNamePlaceholder: 'Naziv usluge',
    priceRsdPlaceholder: 'Cena (RSD)',
    addItemBtn: '+ Dodaj',
    noItemsYet: 'Još nema dodatih stavki.',
    productsNote: 'Napomena: ova lista se trenutno čuva samo tokom sesije. Trajno čuvanje stavki biće dodato uz proširenje baze (products tabela).',
    subscriptionHeading: 'Pretplata',
    subscriptionSub: 'Planovi i naplata su trenutno u pripremi. Svi korisnici imaju pun pristup tokom beta faze.',
    currentPlanBadge: 'Trenutni plan',
    subscriptionNote: 'Naplata putem kartice ili trajnog naloga biće dostupna uskoro.',
    planSoloName: 'Solo',
    planSoloDesc: 'Za samostalne umetnike i pojedince koji fakturišu za sebe.',
    planSoloFeatures: ['1 klijent (umetnik)', 'Neograničen broj faktura', 'KPO knjiga', 'Praćenje limita'],
    planAgencyName: 'Agencija',
    planAgencyDesc: 'Za agencije koje upravljaju fakturisanjem za više klijenata.',
    planAgencyFeatures: ['Neograničen broj klijenata', 'Sve iz Solo plana', 'Tim pristup (uskoro)', 'Prioritetna podrška'],
    referralsHeading: 'Preporuke',
    referralsSub: 'Pozovite druge umetnike i agencije da koriste FinArt Studio.',
    referralLinkLabel: 'Vaš link za preporuku',
    copiedLabel: '✓ Kopirano',
    copyBtn: 'Kopiraj',
    referralsNote: 'Program nagrađivanja za preporuke je u pripremi.',
    menuAriaLabel: 'Meni',
    logoutBtn: 'Odjava',
    yourAgenciesHeading: 'Vaše agencije',
    addAgencyOrClient: 'Dodaj agenciju / klijenta',
    agencyNamePlaceholder: 'Naziv (npr. ime klijenta)',
    cancelBtn: 'Otkaži',
    saveBtnShort: 'Sačuvaj',
    noAgenciesYet: 'Još nemate dodatu agenciju. Kliknite na karticu iznad da dodate prvu.',
    resetPasswordError: 'Greška prilikom postavljanja nove lozinke. Pokušajte ponovo sa linka u emailu.',
    setNewPasswordHeading: 'Postavite novu lozinku',
    passwordChangedRedirect: 'Lozinka je uspešno promenjena. Preusmeravamo vas...',
    newPasswordShortPlaceholder: 'Nova lozinka',
    saveNewPasswordBtn: 'Sačuvaj novu lozinku',
    thanksForSigningUp: 'Hvala na registraciji!',
    verifyEmailBodyPrefix: 'Pre nego što počnete da koristite FinArt Studio, molimo vas da potvrdite svoju email adresu klikom na link koji smo poslali na',
    newVerificationLinkSent: 'Novi verifikacioni link je poslat na vašu email adresu.',
    sendingEllipsis: 'Slanje...',
    resendVerificationBtn: 'Pošalji verifikacioni link ponovo',
    logOutLink: 'Izloguj se',
    remainingLabel: (amount) => `Preostalo: ${amount}`,
    navSectionAgency: 'Agencija',
    navHome: 'Početna',
    navFiscalCash: 'Fiskalna kasa',
    navNewBadge: 'Novo',
    navSectionBusiness: 'Poslovanje',
    navProducts: 'Proizvodi i usluge',
    navKpoBook: 'KPO knjiga',
    navExchangeList: 'Kursna lista',
    navTaxCalendar: 'Poreski kalendar',
    navSectionSettings: 'Podešavanja',
    closeMenuAria: 'Zatvori meni',
    yourAgencyDefault: 'Vaša agencija',
    switchHint: 'Promeni ›',
    backToLogin: '← Nazad na prijavu',
    invoiceNumberPlaceholder: 'npr. 2026-001',
    ratePlaceholder: 'npr. 117.50',
  },
  en: {
    appName: 'FinArt Studio',
    login: 'Sign in',
    register: 'Sign up',
    email: 'Email',
    password: 'Password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot your password?',
    noAccount: "Don't have an account?",
    signUp: 'Sign up',
    haveAccount: 'Already have an account?',
    signIn: 'Sign in',
    dashboard: 'Dashboard',
    invoicing: 'Invoicing',
    fiscalCash: 'Fiscal cash register',
    taxes: 'Taxes & contributions',
    clients: 'Clients',
    products: 'Products & services',
    kpoBook: 'Income ledger (KPO)',
    exchangeList: 'Exchange rates',
    taxCalendar: 'Tax calendar',
    userProfile: 'User profile',
    agency: 'Agency',
    subscription: 'Subscription',
    referrals: 'Referrals',
    newInvoice: 'New Invoice',
    newProforma: 'New Proforma',
    newClient: 'New client',
    limits: 'Limits',
    invoicedYear: 'Invoiced (this yr.)',
    collected365: 'Collected (365 days)',
    remaining: 'Remaining',
    nextDeadline: 'Next deadline',
    monthlyDue: 'Monthly amount due',
    markPaid: 'Mark as paid',
    paid: 'Paid',
    dueSoon: 'In 10 days',
    topClients: 'Top 4 clients',
    allClients: 'All customers',
    foreignEntity: 'Foreign entity',
    countryLabel: 'Country',
    deleteCustomerBtn: 'Delete client',
    deleteCustomerConfirm1: (name) => `Do you want to delete the customer "${name}"?`,
    deleteCustomerConfirm2: 'Final check: deletion is permanent and cannot be undone.',
    deleteContinueBtn: 'Continue',
    deleteFinalBtn: 'Yes, delete permanently',
    deletingEllipsis: 'Deleting...',
    yearLabel: 'Year',
    switchAccount: 'Switch account',
    yearTotalShort: (y) => `Total ${y}`,
    addAccountBtn: 'Add account',
    daysLeft: (n) => `in ${n} ${n === 1 ? 'day' : 'days'}`,
    limitRemaining: (rest, pct) => `Remaining ${rest} · ${pct} used`,
    tabAllClients: 'All clients',
    stAll: 'All',
    stDraft: 'Draft',
    stSent: 'Sent',
    stPaid: 'Paid',
    stCancelled: 'Cancelled',
    stPartial: 'Partial',
    statInvoiced: 'Invoiced (RSD)',
    statPaid: 'Paid (RSD)',
    statUnpaid: 'Unpaid (RSD)',
    statCount: 'Invoices',
    tabInvoicesOnly: 'Invoices',
    tabFiscalOnly: 'Fiscal receipts',
    downloadReport: 'Download report',
    markPaidAction: 'Mark as paid',
    changeStatus: 'Change status',
    partialAmountLabel: (cur) => `Paid (${cur})`,
    colSeqShort: 'No.',
    colInvoiceNo: 'Invoice no.',
    colInvoiceDate: 'Invoice date',
    colTotal: 'Total',
    colStatus: 'Status',
    paidOfTotal: (p) => `${p} paid`,
    tabDomestic: 'Domestic',
    tabForeign: 'Foreign',
    colName: 'Name',
    colAddress: 'Address',
    colMb: 'Reg. number',
    showLabel: 'Show:',
    viewBtn: 'View',
    pageRange: (a, b, n) => `${a}–${b} of ${n}`,
    prevPage: 'Previous',
    nextPage: 'Next',
    clientDocuments: "Client's documents",
    noClientDocuments: 'No documents issued for this client yet.',
    clientDetailsTitle: 'Client details',
    searchAgenciesPlaceholder: 'Search by name (e.g. Zlatan, Vidovic)...',
    myAgencyLabel: 'My agency',
    renameAgency: 'Rename',
    markAsMine: 'Mark as my agency',
    unmarkMine: 'Remove mark',
    agenciesCount: (n) => `${n} ${n === 1 ? 'account' : 'accounts'}`,
    starTip: 'Tip: click ☆ next to your agency to keep it at the top of the list.',
    backToCurrentYear: (y) => `← Back to ${y}`,
    editDocumentHeading: 'Edit document',
    numberSuggestedNote: 'Suggested next number — you can change it.',
    deleteInvoiceConfirm1: (num) => `Do you want to delete document${num ? ' ' + num : ''}? It will also be removed from the KPO ledger and limits.`,
    deleteInvoiceConfirm2: 'Final check: deleting a document is permanent and cannot be undone.',
    customerHasInvoices: (n) => `This customer can't be deleted because it is linked to ${n} ${n === 1 ? 'document' : 'documents'}. Issued invoices must keep the recipient's details.`,
    domesticEntity: 'Domestic entity',
    currentYear: 'Current year',
    lastYear: 'Last year',
    months3: '3 months',
    months6: '6 months',
    all: 'All',
    logout: 'Sign out',
    brandHeadline1: 'You create the art,',
    brandHeadline2: 'we take care of your finances.',
    brandSub: 'Tax and administrative services for artists and agencies.',
    loadingGeneric: 'Loading...',
    taxesCard: 'Taxes',
    yearSuffix: '',
    paidShort: '✓ Paid',
    savingEllipsis: 'Saving...',
    deadlinePassed: 'Deadline has passed',
    nextPaymentIn: (n) => `Next payment in ${n} days`,
    invoicedTitle: 'Invoiced',
    noInvoicedYet: 'No invoiced amounts yet.',
    allClientsArrow: 'All clients →',
    newDocument: '+ New document',
    filterAll: 'All',
    filterInvoices: 'Invoices',
    filterProforma: 'Proformas',
    filterFiscal: 'Fiscal',
    noDocuments: 'No documents to display.',
    kindInvoice: 'Invoice',
    kindProforma: 'Proforma',
    kindFiscal: 'Fiscal',
    newClientBtn: '+ Add client',
    searchClients: 'Search',
    noClientsYet: "You haven't added any customers yet.",
    noSearchResults: 'No results found.',
    backToClients: '← Clients',
    editClient: 'Edit client',
    newClientHeading: 'New client',
    pibLabel: 'Tax ID (PIB)',
    pibPlaceholder: 'Enter tax ID',
    fullNameLabel: 'Full name / business name *',
    fullNamePlaceholder: 'e.g. John Smith',
    agencyNameLabel: 'Agency / company name',
    mbLabel: 'Registration number',
    regDateLabel: 'Registration date',
    activityCodeLabel: 'Activity code',
    chooseActivityCode: 'Choose activity code',
    cityLabel: 'City',
    postalCodeLabel: 'Postal code',
    streetLabel: 'Street',
    streetNumberLabel: 'Number',
    phoneLabel: 'Phone',
    emailLabel: 'Email',
    domesticAccountSection: 'Domestic account (RSD)',
    accountNumberLabel: 'Account number',
    foreignAccountSection: 'Foreign account (FX)',
    ibanLabel: 'IBAN',
    bankNameLabel: 'Bank name',
    swiftLabel: 'SWIFT/BIC',
    savingEllipsisShort: 'Saving...',
    saveChanges: 'Save changes',
    addClientBtn: 'Add customer',
    backArrow: '← Back',
    newDocumentHeading: 'New document',
    docKindInvoice: 'Invoice',
    docKindProforma: 'Proforma',
    docKindFiscal: 'Fiscal receipt',
    actorLabel: 'Client (artist you are invoicing for) *',
    chooseClient: 'Choose client',
    invoiceTypeLabel: 'Invoice type',
    domesticTab: 'Domestic',
    foreignTab: 'Foreign',
    foreignInfoPrefix: 'ℹ️ Foreign invoices',
    foreignInfoNotIncl: 'do not count',
    foreignInfoMid: 'toward the VAT limit (8M), but',
    foreignInfoIncl: 'do count',
    foreignInfoSuffix: 'toward the flat-rate limit (6M).',
    accountPrefix: 'Account: ',
    ibanPrefix: 'IBAN: ',
    customerLabel: 'Customer (who the document is issued to)',
    documentNumberLabel: 'Document number',
    serviceDescLabel: 'Service description *',
    serviceDescPlaceholder: 'e.g. Performance fee',
    issueDateLabel: 'Issue date *',
    serviceDateLabel: 'Service date *',
    placeOfIssueLabel: 'Place of issue',
    placeOfIssuePlaceholder: 'e.g. Belgrade',
    amountRsdLabel: 'Amount (RSD) *',
    amountLabel: 'Amount *',
    currencyLabel: 'Currency *',
    rateLabel: (cur) => `Rate (${cur} → RSD) *`,
    nbsButton: 'NBS rate',
    nbsNote: (date) => `NBS middle rate as of ${date}`,
    saveDocument: 'Save document',
    kpoTitle: 'Income ledger (KPO)',
    printPdf: 'Print / PDF',
    kpoSub: 'Revenue ledger for flat-rate taxed entrepreneurs.',
    noRecordsForYear: (y) => `No recorded documents for ${y}.`,
    colSeq: 'No.',
    colServiceDate: 'Service date',
    colPaymentDate: 'Payment date',
    colCustomer: 'Customer',
    colAmountRsd: 'Amount (RSD)',
    totalForYear: (y) => `TOTAL FOR ${y}:`,
    taxesHeading: 'Taxes & contributions',
    taxesSub: 'Record of flat-rate tax and contribution payments by month.',
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    exchangeError: 'Could not fetch exchange rates. Please try again later.',
    exchangeHeading: 'Exchange rates',
    fetchNbsBtn: 'Fetch NBS rate',
    exchangeSub: 'National Bank of Serbia middle rate for selected currencies.',
    exchangeEmpty: 'Click "Fetch NBS rate" to load the current exchange rates.',
    notAvailable: 'Not available',
    taxCalendarHeading: 'Tax calendar',
    taxCalendarSub: 'Flat-rate taxpayers pay tax and contributions by the 15th of the month for the previous month.',
    taxRowTitle: 'Tax and contributions — flat rate',
    taxRowSub: (period) => `For period: ${period}`,
    nextDeadlineBadge: 'Next deadline',
    taxNote: (amount) => `The monthly amount due depends on the base and municipality of registration. The indicative amount shown on the dashboard is currently ${amount} — please check the exact amount in your Tax Administration decision.`,
    passwordChanged: 'Password changed successfully.',
    passwordChangeError: 'Error changing password.',
    emailAddress: 'Email address',
    appLanguage: 'App language',
    serbianLabel: 'Serbian',
    englishLabel: 'English',
    russianLabel: 'Russian',
    changePassword: 'Change password',
    newPasswordPlaceholder: 'New password (min. 6 characters)',
    changePasswordBtn: 'Change password',
    companyNameLabel: 'Company name *',
    accountsSection: 'Accounts',
    domesticAccountLabel: 'RSD current account',
    foreignIbanLabel: 'Foreign currency IBAN',
    bankLabel: 'Bank',
    savedNote: 'Saved.',
    welcomeHeading: 'Welcome to FinArt Studio!',
    welcomeSub: "Before we start, tell us where you're starting from. We'll guide you the right way.",
    haveAgencyTitle: 'I already have an agency',
    haveAgencyDesc: 'Have a registered company and tax ID? Add it to the system and create your first invoice.',
    newAgencyTitle: "I'm just opening an agency",
    newAgencyDesc: 'Our team handles the entire registration process with the Business Registers Agency. You provide a copy of your ID and sign a power of attorney.',
    onboardingFootnote: 'Not sure? You can change your mind later. Services are available from the menu.',
    openingAgencyHeading: 'Opening a flat-rate agency',
    openingAgencySub: 'This service is being prepared. For now, please contact us directly by email so we can help you open your company.',
    backArrowOnboarding: '← Back',
    addYourCompanyHeading: 'Add your company',
    addYourCompanySub: 'Add your company details so you can send invoices and track payments.',
    pibFullLabel: 'Tax identification number (PIB)',
    streetSeatLabel: 'Registered office street',
    bankForeignLabel: 'Bank (for foreign currency account)',
    saveAndContinue: 'Save and continue',
    newManualCustomer: 'New customer — manual entry',
    backToSearch: '← Search',
    customerNamePlaceholder: 'Customer name *',
    pibShort: 'Tax ID',
    mbShort: 'Registration number',
    addressPlaceholder: 'Address',
    cityPlaceholder: 'City',
    postalCodePlaceholder: 'Postal code',
    foreignEntityCheckbox: 'Foreign entity',
    saveCustomerBtn: 'Save customer and use on invoice',
    typeCustomerName: 'Start typing customer name...',
    newManualBtn: '+ New customer (manual entry)',
    confirmDeleteDocument: 'Delete this document?',
    confirmDeleteClient: 'Delete this client and all their invoices?',
    editBtn: 'Edit',
    deleteBtn: 'Delete',
    totalBalance: 'Total balance',
    domesticRsdLabel: 'Domestic (RSD)',
    foreignLabel: (cur) => `Foreign (${cur})`,
    flatRateLimitsTitle: 'Flat-rate limits',
    flatRateCalYear: (y) => `Flat-rate — calendar year ${y}`,
    vatLast365: 'VAT — last 365 days',
    documentsTab: 'Documents',
    profileTab: 'Client profile',
    documentsCount: (n) => `Documents (${n})`,
    domesticFilterFlag: 'Domestic',
    foreignFilterFlag: 'Foreign',
    noDocuments2: 'No documents.',
    issuedShort: (date) => `Issued: ${date}`,
    pdfBtn: 'PDF',
    fullNameInfo: 'Full name',
    agencyInfo: 'Agency',
    addressInfo: 'Address',
    activityCodeInfo: 'Activity code',
    domesticAccountSectionInfo: 'Domestic account',
    accountNumberInfo: 'Account number',
    foreignAccountSectionInfo: 'Foreign account',
    bankInfo: 'Bank',
    notSetInfo: 'Not set',
    documentNotFound: 'Document not found.',
    printSaveBtn: 'Print / Save PDF',
    productsHeading: 'Products & services',
    productsSub: 'Save frequently used items to fill out invoices faster.',
    serviceNamePlaceholder: 'Service name',
    priceRsdPlaceholder: 'Price (RSD)',
    addItemBtn: '+ Add',
    noItemsYet: 'No items added yet.',
    productsNote: 'Note: this list is currently only kept for the session. Permanent storage of items will be added with a database extension (products table).',
    subscriptionHeading: 'Subscription',
    subscriptionSub: 'Plans and billing are currently being prepared. All users have full access during the beta phase.',
    currentPlanBadge: 'Current plan',
    subscriptionNote: 'Billing via card or standing order will be available soon.',
    planSoloName: 'Solo',
    planSoloDesc: 'For independent artists and individuals invoicing for themselves.',
    planSoloFeatures: ['1 client (artist)', 'Unlimited invoices', 'KPO ledger', 'Limit tracking'],
    planAgencyName: 'Agency',
    planAgencyDesc: 'For agencies managing invoicing for multiple clients.',
    planAgencyFeatures: ['Unlimited clients', 'Everything in Solo plan', 'Team access (coming soon)', 'Priority support'],
    referralsHeading: 'Referrals',
    referralsSub: 'Invite other artists and agencies to use FinArt Studio.',
    referralLinkLabel: 'Your referral link',
    copiedLabel: '✓ Copied',
    copyBtn: 'Copy',
    referralsNote: 'A referral rewards program is being prepared.',
    menuAriaLabel: 'Menu',
    logoutBtn: 'Log out',
    yourAgenciesHeading: 'Your agencies',
    addAgencyOrClient: 'Add agency / client',
    agencyNamePlaceholder: 'Name (e.g. client name)',
    cancelBtn: 'Cancel',
    saveBtnShort: 'Save',
    noAgenciesYet: "You haven't added an agency yet. Click the card above to add your first one.",
    resetPasswordError: 'Error setting the new password. Please try again from the link in your email.',
    setNewPasswordHeading: 'Set a new password',
    passwordChangedRedirect: 'Password changed successfully. Redirecting you...',
    newPasswordShortPlaceholder: 'New password',
    saveNewPasswordBtn: 'Save new password',
    thanksForSigningUp: 'Thanks for signing up!',
    verifyEmailBodyPrefix: 'Before you start using FinArt Studio, please confirm your email address by clicking the link we sent to',
    newVerificationLinkSent: 'A new verification link has been sent to your email address.',
    sendingEllipsis: 'Sending...',
    resendVerificationBtn: 'Resend verification link',
    logOutLink: 'Log out',
    remainingLabel: (amount) => `Remaining: ${amount}`,
    navSectionAgency: 'Agency',
    navHome: 'Home',
    navFiscalCash: 'Fiscal till',
    navNewBadge: 'New',
    navSectionBusiness: 'Business',
    navProducts: 'Products & services',
    navKpoBook: 'KPO ledger',
    navExchangeList: 'Exchange rates',
    navTaxCalendar: 'Tax calendar',
    navSectionSettings: 'Settings',
    closeMenuAria: 'Close menu',
    yourAgencyDefault: 'Your agency',
    switchHint: 'Switch ›',
    backToLogin: '← Back to sign in',
    invoiceNumberPlaceholder: 'e.g. 2026-001',
    ratePlaceholder: 'e.g. 117.50',
  },
  ru: {
    appName: 'FinArt Studio',
    login: 'Вход',
    register: 'Регистрация',
    email: 'Email',
    password: 'Пароль',
    rememberMe: 'Запомнить меня',
    forgotPassword: 'Забыли пароль?',
    noAccount: 'Ещё нет аккаунта?',
    signUp: 'Зарегистрироваться',
    haveAccount: 'Уже есть аккаунт?',
    signIn: 'Войти',
    dashboard: 'Главная',
    invoicing: 'Счета',
    fiscalCash: 'Фискальная касса',
    taxes: 'Налоги и взносы',
    clients: 'Клиенты',
    products: 'Товары и услуги',
    kpoBook: 'Книга доходов (KPO)',
    exchangeList: 'Курсы валют',
    taxCalendar: 'Налоговый календарь',
    userProfile: 'Профиль пользователя',
    agency: 'Агентство',
    subscription: 'Подписка',
    referrals: 'Рекомендации',
    newInvoice: 'Новый счёт',
    newProforma: 'Новый проформа-счёт',
    newClient: 'Новый клиент',
    limits: 'Лимиты',
    invoicedYear: 'Выставлено (в этом году)',
    collected365: 'Получено (365 дней)',
    remaining: 'Осталось',
    nextDeadline: 'Следующий срок',
    monthlyDue: 'Ежемесячная сумма к оплате',
    markPaid: 'Отметить как оплачено',
    paid: 'Оплачено',
    dueSoon: 'Через 10 дней',
    topClients: 'Топ-4 клиента',
    allClients: 'Все клиенты',
    foreignEntity: 'Иностранное лицо',
    countryLabel: 'Страна',
    deleteCustomerBtn: 'Удалить клиента',
    deleteCustomerConfirm1: (name) => `Удалить клиента «${name}»?`,
    deleteCustomerConfirm2: 'Последняя проверка: удаление необратимо.',
    deleteContinueBtn: 'Продолжить',
    deleteFinalBtn: 'Да, удалить навсегда',
    deletingEllipsis: 'Удаление...',
    yearLabel: 'Год',
    switchAccount: 'Сменить аккаунт',
    yearTotalShort: (y) => `Итого ${y}`,
    addAccountBtn: 'Добавить аккаунт',
    daysLeft: (n) => `через ${n} ${n % 10 === 1 && n % 100 !== 11 ? 'день' : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'дня' : 'дней')}`,
    limitRemaining: (rest, pct) => `Осталось ${rest} · использовано ${pct}`,
    tabAllClients: 'Все клиенты',
    stAll: 'Все',
    stDraft: 'В подготовке',
    stSent: 'Отправлен',
    stPaid: 'Оплачен',
    stCancelled: 'Сторнирован',
    stPartial: 'Частично',
    statInvoiced: 'Выставлено (RSD)',
    statPaid: 'Оплачено (RSD)',
    statUnpaid: 'Не оплачено (RSD)',
    statCount: 'Счета',
    tabInvoicesOnly: 'Счета',
    tabFiscalOnly: 'Фискальные чеки',
    downloadReport: 'Скачать отчёт',
    markPaidAction: 'Отметить как оплачено',
    changeStatus: 'Изменить статус',
    partialAmountLabel: (cur) => `Оплачено (${cur})`,
    colSeqShort: '№',
    colInvoiceNo: 'Номер счёта',
    colInvoiceDate: 'Дата счёта',
    colTotal: 'Итого',
    colStatus: 'Статус',
    paidOfTotal: (p) => `оплачено ${p}`,
    tabDomestic: 'Сербские',
    tabForeign: 'Иностранные',
    colName: 'Название',
    colAddress: 'Адрес',
    colMb: 'Рег. номер',
    showLabel: 'Показать:',
    viewBtn: 'Открыть',
    pageRange: (a, b, n) => `${a}–${b} из ${n}`,
    prevPage: 'Назад',
    nextPage: 'Далее',
    clientDocuments: 'Документы клиента',
    noClientDocuments: 'Для этого клиента пока нет документов.',
    clientDetailsTitle: 'Данные клиента',
    searchAgenciesPlaceholder: 'Поиск по имени (напр. Zlatan, Vidovic)...',
    myAgencyLabel: 'Моё агентство',
    renameAgency: 'Переименовать',
    markAsMine: 'Отметить как моё агентство',
    unmarkMine: 'Снять отметку',
    agenciesCount: (n) => `${n} ${n % 10 === 1 && n % 100 !== 11 ? 'аккаунт' : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'аккаунта' : 'аккаунтов')}`,
    starTip: 'Совет: нажмите ☆ рядом со своим агентством, чтобы оно всегда было вверху списка.',
    backToCurrentYear: (y) => `← Вернуться к ${y}`,
    editDocumentHeading: 'Изменить документ',
    numberSuggestedNote: 'Предложен следующий номер — его можно изменить.',
    deleteInvoiceConfirm1: (num) => `Удалить документ${num ? ' ' + num : ''}? Он также исчезнет из книги KPO и лимитов.`,
    deleteInvoiceConfirm2: 'Последняя проверка: удаление документа необратимо.',
    customerHasInvoices: (n) => `Этого клиента нельзя удалить: с ним связано документов: ${n}. Выставленные счета должны сохранять данные получателя.`,
    domesticEntity: 'Сербское лицо',
    currentYear: 'Текущий год',
    lastYear: 'Прошлый год',
    months3: '3 месяца',
    months6: '6 месяцев',
    all: 'Все',
    logout: 'Выйти',
    brandHeadline1: 'Вы создаёте искусство,',
    brandHeadline2: 'мы заботимся о ваших финансах.',
    brandSub: 'Налоговые и административные услуги для артистов и агентств.',
    loadingGeneric: 'Загрузка...',
    taxesCard: 'Налоги',
    yearSuffix: '',
    paidShort: '✓ Оплачено',
    savingEllipsis: 'Сохранение...',
    deadlinePassed: 'Срок истёк',
    nextPaymentIn: (n) => `Следующий платёж через ${n} дн.`,
    invoicedTitle: 'Выставлено',
    noInvoicedYet: 'Пока нет выставленных сумм.',
    allClientsArrow: 'Все клиенты →',
    newDocument: '+ Новый документ',
    filterAll: 'Все',
    filterInvoices: 'Счета',
    filterProforma: 'Проформы',
    filterFiscal: 'Фискальные',
    noDocuments: 'Нет документов для отображения.',
    kindInvoice: 'Счёт',
    kindProforma: 'Проформа',
    kindFiscal: 'Фискальный',
    newClientBtn: '+ Добавить клиента',
    searchClients: 'Поиск',
    noClientsYet: 'Вы ещё не добавили ни одного клиента.',
    noSearchResults: 'Ничего не найдено.',
    backToClients: '← Клиенты',
    editClient: 'Изменить клиента',
    newClientHeading: 'Новый клиент',
    pibLabel: 'ИНН (PIB)',
    pibPlaceholder: 'Введите ИНН',
    fullNameLabel: 'Полное имя / название *',
    fullNamePlaceholder: 'напр. Marko Marković',
    agencyNameLabel: 'Название агентства / компании',
    mbLabel: 'Рег. номер (MB)',
    regDateLabel: 'Дата регистрации',
    activityCodeLabel: 'Код деятельности',
    chooseActivityCode: 'Выберите код деятельности',
    cityLabel: 'Город',
    postalCodeLabel: 'Почтовый индекс',
    streetLabel: 'Улица',
    streetNumberLabel: 'Номер',
    phoneLabel: 'Телефон',
    emailLabel: 'Email',
    domesticAccountSection: 'Динарный счёт (RSD)',
    accountNumberLabel: 'Номер счёта',
    foreignAccountSection: 'Валютный счёт',
    ibanLabel: 'IBAN',
    bankNameLabel: 'Название банка',
    swiftLabel: 'SWIFT/BIC',
    savingEllipsisShort: 'Сохранение...',
    saveChanges: 'Сохранить изменения',
    addClientBtn: 'Добавить клиента',
    backArrow: '← Назад',
    newDocumentHeading: 'Новый документ',
    docKindInvoice: 'Счёт',
    docKindProforma: 'Проформа',
    docKindFiscal: 'Фискальный чек',
    actorLabel: 'Клиент (артист, за которого выставляется счёт) *',
    chooseClient: 'Выберите клиента',
    invoiceTypeLabel: 'Тип счёта',
    domesticTab: 'Сербский',
    foreignTab: 'Иностранный',
    foreignInfoPrefix: 'ℹ️ Иностранные счета',
    foreignInfoNotIncl: 'не входят',
    foreignInfoMid: 'в лимит НДС (8 млн), но',
    foreignInfoIncl: 'входят',
    foreignInfoSuffix: 'в лимит паушала (6 млн).',
    accountPrefix: 'Счёт: ',
    ibanPrefix: 'IBAN: ',
    customerLabel: 'Покупатель (кому выставляется документ)',
    documentNumberLabel: 'Номер документа',
    serviceDescLabel: 'Описание услуги *',
    serviceDescPlaceholder: 'напр. Гонорар за выступление',
    issueDateLabel: 'Дата выставления *',
    serviceDateLabel: 'Дата оказания услуги *',
    placeOfIssueLabel: 'Место оказания услуги',
    placeOfIssuePlaceholder: 'напр. Белград',
    amountRsdLabel: 'Сумма (RSD) *',
    amountLabel: 'Сумма *',
    currencyLabel: 'Валюта *',
    rateLabel: (cur) => `Курс (${cur} → RSD) *`,
    nbsButton: 'Курс НБС',
    nbsNote: (date) => `Средний курс НБС на ${date}`,
    saveDocument: 'Сохранить документ',
    kpoTitle: 'Книга доходов (KPO)',
    printPdf: 'Печать / PDF',
    kpoSub: 'Книга доходов для предпринимателей на паушальном налоге.',
    noRecordsForYear: (y) => `Нет документов за ${y}.`,
    colSeq: '№',
    colServiceDate: 'Дата услуги',
    colPaymentDate: 'Дата оплаты',
    colCustomer: 'Покупатель',
    colAmountRsd: 'Сумма (RSD)',
    totalForYear: (y) => `ИТОГО ЗА ${y}:`,
    taxesHeading: 'Налоги и взносы',
    taxesSub: 'Учёт уплаты паушального налога и взносов по месяцам.',
    monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    exchangeError: 'Не удалось получить курсы валют. Попробуйте позже.',
    exchangeHeading: 'Курсы валют',
    fetchNbsBtn: 'Получить курс НБС',
    exchangeSub: 'Средний курс Народного банка Сербии для выбранных валют.',
    exchangeEmpty: 'Нажмите «Получить курс НБС», чтобы загрузить текущие курсы.',
    notAvailable: 'Нет данных',
    taxCalendarHeading: 'Налоговый календарь',
    taxCalendarSub: 'Паушалисты платят налог и взносы до 15-го числа месяца за предыдущий месяц.',
    taxRowTitle: 'Налог и взносы — паушал',
    taxRowSub: (period) => `За период: ${period}`,
    nextDeadlineBadge: 'Следующий срок',
    taxNote: (amount) => `Ежемесячная сумма зависит от базы и муниципалитета регистрации. Ориентировочная сумма на главной странице сейчас ${amount} — точную сумму проверьте в решении Налоговой службы.`,
    passwordChanged: 'Пароль успешно изменён.',
    passwordChangeError: 'Ошибка при смене пароля.',
    emailAddress: 'Адрес email',
    appLanguage: 'Язык приложения',
    serbianLabel: 'Сербский',
    englishLabel: 'Английский',
    russianLabel: 'Русский',
    changePassword: 'Сменить пароль',
    newPasswordPlaceholder: 'Новый пароль',
    changePasswordBtn: 'Сменить пароль',
    companyNameLabel: 'Название компании *',
    accountsSection: 'Счета',
    domesticAccountLabel: 'Текущий динарный счёт',
    foreignIbanLabel: 'Валютный IBAN',
    bankLabel: 'Банк',
    savedNote: 'Сохранено.',
    welcomeHeading: 'Добро пожаловать в FinArt Studio!',
    welcomeSub: 'Прежде чем начать, расскажите, с чего вы начинаете. Мы подскажем правильный путь.',
    haveAgencyTitle: 'У меня уже есть агентство',
    haveAgencyDesc: 'Есть зарегистрированная фирма и ИНН? Добавьте её в систему и выставьте первый счёт.',
    newAgencyTitle: 'Я только открываю агентство',
    newAgencyDesc: 'Наша команда проведёт всю регистрацию в Агентстве хозяйственных регистров. Вы предоставляете копию паспорта и подписываете доверенность.',
    onboardingFootnote: 'Не уверены? Выбор можно изменить позже. Услуги доступны в меню.',
    openingAgencyHeading: 'Открытие агентства на паушале',
    openingAgencySub: 'Эта услуга готовится. Пока свяжитесь с нами по email, и мы поможем открыть фирму.',
    backArrowOnboarding: '← Назад',
    addYourCompanyHeading: 'Добавьте свою фирму',
    addYourCompanySub: 'Добавьте данные фирмы, чтобы выставлять счета и отслеживать оплаты.',
    pibFullLabel: 'Идентификационный номер налогоплательщика (PIB)',
    streetSeatLabel: 'Улица (юридический адрес)',
    bankForeignLabel: 'Банк (для валютного счёта)',
    saveAndContinue: 'Сохранить и продолжить',
    newManualCustomer: 'Новый клиент — ручной ввод',
    backToSearch: '← Поиск',
    customerNamePlaceholder: 'Название клиента *',
    pibShort: 'ИНН',
    mbShort: 'Рег. номер',
    addressPlaceholder: 'Адрес',
    cityPlaceholder: 'Город',
    postalCodePlaceholder: 'Почтовый индекс',
    foreignEntityCheckbox: 'Иностранное лицо',
    saveCustomerBtn: 'Сохранить клиента и использовать в счёте',
    typeCustomerName: 'Начните вводить название клиента...',
    newManualBtn: '+ Новый клиент (ручной ввод)',
    confirmDeleteDocument: 'Удалить этот документ?',
    confirmDeleteClient: 'Удалить этого клиента и все его счета?',
    editBtn: 'Изменить',
    deleteBtn: 'Удалить',
    totalBalance: 'Общий баланс',
    domesticRsdLabel: 'Сербские (RSD)',
    foreignLabel: (cur) => `Иностранные (${cur})`,
    flatRateLimitsTitle: 'Лимиты паушала',
    flatRateCalYear: (y) => `Паушал — календарный год ${y}`,
    vatLast365: 'НДС — последние 365 дней',
    documentsTab: 'Документы',
    profileTab: 'Профиль клиента',
    documentsCount: (n) => `Документы (${n})`,
    domesticFilterFlag: 'Сербские',
    foreignFilterFlag: 'Иностранные',
    noDocuments2: 'Нет документов.',
    issuedShort: (date) => `Выставлен: ${date}`,
    pdfBtn: 'PDF',
    fullNameInfo: 'Полное имя',
    agencyInfo: 'Агентство',
    addressInfo: 'Адрес',
    activityCodeInfo: 'Код деятельности',
    domesticAccountSectionInfo: 'Динарный счёт',
    accountNumberInfo: 'Номер счёта',
    foreignAccountSectionInfo: 'Валютный счёт',
    bankInfo: 'Банк',
    notSetInfo: 'Не указано',
    documentNotFound: 'Документ не найден.',
    printSaveBtn: 'Печать / Сохранить PDF',
    productsHeading: 'Товары и услуги',
    productsSub: 'Сохраняйте часто используемые позиции, чтобы быстрее заполнять счета.',
    serviceNamePlaceholder: 'Название услуги',
    priceRsdPlaceholder: 'Цена (RSD)',
    addItemBtn: '+ Добавить',
    noItemsYet: 'Позиции ещё не добавлены.',
    productsNote: 'Примечание: этот список пока хранится только в текущей сессии. Постоянное хранение будет добавлено позже.',
    subscriptionHeading: 'Подписка',
    subscriptionSub: 'Тарифы и оплата сейчас готовятся. В бета-период у всех пользователей полный доступ.',
    currentPlanBadge: 'Текущий тариф',
    subscriptionNote: 'Оплата картой или постоянным поручением скоро будет доступна.',
    planSoloName: 'Solo',
    planSoloDesc: 'Для независимых артистов, выставляющих счета за себя.',
    planSoloFeatures: ['1 клиент (артист)', 'Неограниченное число счетов', 'Книга KPO', 'Контроль лимитов'],
    planAgencyName: 'Агентство',
    planAgencyDesc: 'Для агентств, ведущих счета нескольких клиентов.',
    planAgencyFeatures: ['Неограниченное число клиентов', 'Всё из тарифа Solo', 'Командный доступ (скоро)', 'Приоритетная поддержка'],
    referralsHeading: 'Рекомендации',
    referralsSub: 'Пригласите других артистов и агентства пользоваться FinArt Studio.',
    referralLinkLabel: 'Ваша реферальная ссылка',
    copiedLabel: '✓ Скопировано',
    copyBtn: 'Копировать',
    referralsNote: 'Программа вознаграждений за рекомендации готовится.',
    menuAriaLabel: 'Меню',
    logoutBtn: 'Выйти',
    yourAgenciesHeading: 'Ваши агентства',
    addAgencyOrClient: 'Добавить агентство / клиента',
    agencyNamePlaceholder: 'Название (напр. имя клиента)',
    cancelBtn: 'Отмена',
    saveBtnShort: 'Сохранить',
    noAgenciesYet: 'Вы ещё не добавили агентство. Нажмите на карточку выше, чтобы добавить первое.',
    resetPasswordError: 'Ошибка при установке нового пароля. Попробуйте ещё раз по ссылке из письма.',
    setNewPasswordHeading: 'Установите новый пароль',
    passwordChangedRedirect: 'Пароль успешно изменён. Перенаправляем...',
    newPasswordShortPlaceholder: 'Новый пароль',
    saveNewPasswordBtn: 'Сохранить новый пароль',
    thanksForSigningUp: 'Спасибо за регистрацию!',
    verifyEmailBodyPrefix: 'Прежде чем начать пользоваться FinArt Studio, подтвердите email, нажав на ссылку, которую мы отправили на',
    newVerificationLinkSent: 'Новая ссылка для подтверждения отправлена на ваш email.',
    sendingEllipsis: 'Отправка...',
    resendVerificationBtn: 'Отправить ссылку ещё раз',
    logOutLink: 'Выйти',
    remainingLabel: (amount) => `Осталось: ${amount}`,
    navSectionAgency: 'Агентство',
    navHome: 'Главная',
    navFiscalCash: 'Фискальная касса',
    navNewBadge: 'Новое',
    navSectionBusiness: 'Бизнес',
    navProducts: 'Товары и услуги',
    navKpoBook: 'Книга KPO',
    navExchangeList: 'Курсы валют',
    navTaxCalendar: 'Налоговый календарь',
    navSectionSettings: 'Настройки',
    closeMenuAria: 'Закрыть меню',
    yourAgencyDefault: 'Ваше агентство',
    switchHint: 'Сменить ›',
    backToLogin: '← Назад ко входу',
    invoiceNumberPlaceholder: 'напр. 01/2026',
    ratePlaceholder: 'напр. 117.50',
  },
};

// Prevodi tekstova napisanih direktno na srpskom u novijim stranicama (ključ = srpski tekst)
export const EN_BY_SR = {
  'Datum fakture': 'Invoice date',
  'Datum valute': 'Due date',
  'Ne prikazuje se': 'Not shown',
  'Datum prometa': 'Service date',
  'Mesto prometa': 'Place of supply',
  'Klijent': 'Client',
  'Od': 'From',
  'Ime:': 'Name:',
  'Adresa:': 'Address:',
  'Tekući račun:': 'Account:',
  'Dopuni račun na stranici Agencija →': 'Add the account on the Agency page →',
  'Jedinica mere': 'Unit',
  'Količina': 'Quantity',
  'Cena': 'Price',
  'Popust %': 'Discount %',
  'Ukupno': 'Total',
  'Poruka': 'Message',
  'Međuiznos:': 'Subtotal:',
  'Popust:': 'Discount:',
  'Ukupno:': 'Total:',
  'U dinarima:': 'In RSD:',
  'Naziv usluge ili proizvoda': 'Service or product name',
  'Upiši jedinicu (opciono)': 'Enter a unit (optional)',
  '— prazno / upiši sami —': '— empty / custom —',
  'Dodaj uslugu ili proizvod': 'Add service or product',
  'Ukloni stavku': 'Remove item',
  'Za čuvanje:': 'To save:',
  'dodajte bar jednu stavku': 'add at least one item',
  'svaka stavka mora imati naziv i količinu': 'each item needs a name and a quantity',
  'ukupan iznos mora biti veći od nule': 'the total must be greater than zero',
  'izaberite klijenta (ili ga dodajte preko "Novi klijent")': 'choose a client (or add one via "New customer")',
  'unesite kurs za': 'enter the exchange rate for',
  '(pun naziv)': '(full name)',
  '(skraćeni naziv)': '(short name)',
  'Sačuvaj': 'Save',
  'npr. Rok plaćanja 15 dana. Hvala na saradnji!': 'e.g. Payment due within 15 days. Thank you!',
  'Uvezi iz Excela': 'Import from Excel',
  'Najnovije prvo': 'Newest first',
  'Najstarije prvo': 'Oldest first',
  'Promeni redosled': 'Change order',
  'Proširi meni': 'Expand menu',
  'Skupi meni': 'Collapse menu',
  'Obriši nalog': 'Delete account',
  'Dodaj logo': 'Add logo',
  'Ime i prezime obveznika': 'Owner full name',
  'Izbor možeš promeniti i na svakoj fakturi posebno.': 'You can also change it on each invoice.',
  'Logo na fakturi': 'Invoice logo',
  'Na fakturi podrazumevano štampaj:': 'Print on invoices by default:',
  'Nema loga': 'No logo',
  'PNG, JPG ili SVG. Slika se sama smanji.': 'PNG, JPG or SVG. Resized automatically.',
  'Podaci o firmi': 'Company details',
  'Promeni logo': 'Change logo',
  'Pun naziv firme *': 'Full company name *',
  'Pun naziv': 'Full name',
  'Skraćeni naziv firme': 'Short company name',
  'Skraćeni naziv': 'Short name',
  'Ukloni logo': 'Remove logo',
  'npr. FinArt Studio': 'e.g. FinArt Studio',
  'Ako je uplaćen ceo iznos, faktura postaje "Naplaćeno", inače "Delimično".': 'Full amount marks it Paid, otherwise Partial.',
  'Da, storniraj': 'Yes, cancel it',
  'Da, trajno obriši': 'Yes, delete',
  'Dokument nije pronađen.': 'Document not found.',
  'Izmeni': 'Edit',
  'Napravi kopiju': 'Duplicate',
  'Nastavi': 'Continue',
  'Obriši': 'Delete',
  'Otkaži': 'Cancel',
  'Poslednja provera: brisanje je trajno i ne može se poništiti.': 'Final check: deletion is permanent.',
  'Preostalo za uplatu': 'Remaining',
  'Sačuvaj uplatu': 'Save payment',
  'Storniraj dokument?': 'Cancel this invoice?',
  'Storniraj': 'Cancel invoice',
  'Stornirana faktura ostaje u evidenciji, ali se više ne računa u promet, limite i KPO knjigu.': 'A cancelled invoice stays on record but no longer counts toward turnover or limits.',
  'Unesi uplatu': 'Record payment',
  'Unesite iznos uplate.': 'Enter the payment amount.',
  'Učitavanje...': 'Loading...',
};

export const RU_BY_SR = {
  'Datum fakture': 'Дата счёта',
  'Datum valute': 'Срок оплаты',
  'Ne prikazuje se': 'Не отображается',
  'Datum prometa': 'Дата оказания услуги',
  'Mesto prometa': 'Место оказания услуги',
  'Klijent': 'Клиент',
  'Od': 'От',
  'Ime:': 'Имя:',
  'Adresa:': 'Адрес:',
  'Tekući račun:': 'Текущий счёт:',
  'Dopuni račun na stranici Agencija →': 'Укажите счёт на странице «Агентство» →',
  'Jedinica mere': 'Ед. изм.',
  'Količina': 'Количество',
  'Cena': 'Цена',
  'Popust %': 'Скидка %',
  'Ukupno': 'Итого',
  'Poruka': 'Сообщение',
  'Međuiznos:': 'Промежуточный итог:',
  'Popust:': 'Скидка:',
  'Ukupno:': 'Итого:',
  'U dinarima:': 'В динарах:',
  'Naziv usluge ili proizvoda': 'Название услуги или товара',
  'Upiši jedinicu (opciono)': 'Введите единицу (необязательно)',
  '— prazno / upiši sami —': '— пусто / своя —',
  'Dodaj uslugu ili proizvod': 'Добавить услугу или товар',
  'Ukloni stavku': 'Удалить позицию',
  'Za čuvanje:': 'Для сохранения:',
  'dodajte bar jednu stavku': 'добавьте хотя бы одну позицию',
  'svaka stavka mora imati naziv i količinu': 'у каждой позиции должны быть название и количество',
  'ukupan iznos mora biti veći od nule': 'итоговая сумма должна быть больше нуля',
  'izaberite klijenta (ili ga dodajte preko "Novi klijent")': 'выберите клиента (или добавьте его через «Новый клиент»)',
  'unesite kurs za': 'укажите курс для',
  '(pun naziv)': '(полное название)',
  '(skraćeni naziv)': '(краткое название)',
  'Sačuvaj': 'Сохранить',
  'npr. Rok plaćanja 15 dana. Hvala na saradnji!': 'напр. Срок оплаты 15 дней. Спасибо за сотрудничество!',
  'Uvezi iz Excela': 'Импорт из Excel',
  'Najnovije prvo': 'Сначала новые',
  'Najstarije prvo': 'Сначала старые',
  'Promeni redosled': 'Изменить порядок',
  'Proširi meni': 'Развернуть меню',
  'Skupi meni': 'Свернуть меню',
  'Obriši nalog': 'Удалить аккаунт',
  'Dodaj logo': 'Добавить логотип',
  'Ime i prezime obveznika': 'Имя и фамилия налогоплательщика',
  'Izbor možeš promeniti i na svakoj fakturi posebno.': 'Выбор можно изменить и в каждом счёте отдельно.',
  'Logo na fakturi': 'Логотип в счёте',
  'Na fakturi podrazumevano štampaj:': 'По умолчанию печатать в счёте:',
  'Nema loga': 'Нет логотипа',
  'PNG, JPG ili SVG. Slika se sama smanji.': 'PNG, JPG или SVG. Изображение уменьшается автоматически.',
  'Podaci o firmi': 'Данные фирмы',
  'Promeni logo': 'Сменить логотип',
  'Pun naziv firme *': 'Полное название фирмы *',
  'Pun naziv': 'Полное название',
  'Skraćeni naziv firme': 'Краткое название фирмы',
  'Skraćeni naziv': 'Краткое название',
  'Ukloni logo': 'Удалить логотип',
  'npr. FinArt Studio': 'напр. FinArt Studio',
  'Ako je uplaćen ceo iznos, faktura postaje "Naplaćeno", inače "Delimično".': 'Если оплачена вся сумма, счёт становится «Оплачен», иначе «Частично».',
  'Da, storniraj': 'Да, сторнировать',
  'Da, trajno obriši': 'Да, удалить навсегда',
  'Dokument nije pronađen.': 'Документ не найден.',
  'Izmeni': 'Изменить',
  'Napravi kopiju': 'Сделать копию',
  'Nastavi': 'Продолжить',
  'Obriši': 'Удалить',
  'Otkaži': 'Отмена',
  'Poslednja provera: brisanje je trajno i ne može se poništiti.': 'Последняя проверка: удаление необратимо.',
  'Preostalo za uplatu': 'Осталось оплатить',
  'Sačuvaj uplatu': 'Сохранить оплату',
  'Storniraj dokument?': 'Сторнировать документ?',
  'Storniraj': 'Сторнировать',
  'Stornirana faktura ostaje u evidenciji, ali se više ne računa u promet, limite i KPO knjigu.': 'Сторнированный счёт остаётся в учёте, но больше не учитывается в обороте, лимитах и книге KPO.',
  'Unesi uplatu': 'Внести оплату',
  'Unesite iznos uplate.': 'Введите сумму оплаты.',
  'Učitavanje...': 'Загрузка...',
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem('finart_lang') || 'sr');

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem('finart_lang', l);
  }, []);

  const t = useCallback((key, ...args) => {
    const entry = STRINGS[lang]?.[key] ?? STRINGS.sr[key] ?? key;
    return typeof entry === 'function' ? entry(...args) : entry;
  }, [lang]);

  // tr('srpski tekst', 'engleski', 'ruski'): engleski i ruski su opcioni (inače iz rečnika iznad)
  const tr = useCallback((sr, en, ru) => {
    if (lang === 'ru') return ru ?? RU_BY_SR[sr] ?? en ?? EN_BY_SR[sr] ?? sr;
    if (lang === 'en') return en ?? EN_BY_SR[sr] ?? sr;
    return sr;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang: changeLang, t, tr }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
